import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { defaultIfEmpty, map, Observable, take } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationsReadyGuard implements CanActivate {
  constructor(private translate: TranslocoService) {}

  canActivate(): Observable<boolean> {
    return this.translate.load(this.translate.getActiveLang()).pipe(
      map(() => true),
      defaultIfEmpty(true),
      take(1)
    );
  }
}
